import { createSlice } from '@reduxjs/toolkit';

export const Terminalslice = createSlice({
    name: 'terminal',
    initialState: {
        terminals_list: [],
        terminal: {}
    },
    reducers: {
        setTerminalsRedux: ( state, { payload } ) => {
            state.terminals_list  =  payload;
        }, 
        storeTerminalRedux: ( state, { payload } ) => {
            state.terminal  =  payload;
        }
        
    }
});


// Action creators are generated for each case reducer function
export const { setTerminalsRedux, storeTerminalRedux } = Terminalslice.actions;